import { linkToParentDashboard } from "../../links";

export function linkToChild(userId: string = ":userId") {
  return `${linkToParentDashboard()}/child/${userId}`;
}
